import { modalOpenSelector, modalDataSelector } from '../reducers/modal';
import { withRoot } from '../constants';

const mountSelector = state => state.ui.addProperty;

export const getAddPropertyModalData = withRoot(mountSelector, modalDataSelector);

export const getAddPropertyModalOpen = withRoot(mountSelector, modalOpenSelector);
